





















import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import RulesAndRestrictionsSection from '@app/promotionHub/shared/components/RulesAndRestrictionsSection.vue';
import { Condition } from '@app/promotionHub/shared/types/Condition';
import { BonusKind } from '@core/models/bonus/Bonus';
import { PromotionBonus } from '@app/promotionHub/promotions/types/Promotion';
import { getBetlerBonusSummary } from '@app/promotionHub/bonuses/utils/bonusHelpers';
import PromotionDetailsBonusSection from '@app/promotionHub/shared/components/PromotionDetailsBonusSection.vue';

export default defineComponent({
    name: 'PromotionDetails',
    props: {
        conditions: {
            type: Array as PropType<Condition[]>,
            required: false,
            default: () => ([]),
        },
        kind: {
            type: String as PropType<BonusKind>,
            required: true,
        },
        promotionId: {
            type: [Number, String],
            required: true,
        },
        isPromotionWelcomeOffer: {
            type: Boolean,
            required: false,
        },
        bonus: {
            type: Object as PropType<PromotionBonus>,
            required: true,
        },
        bonusValue: {
            type: String,
            required: false,
            default: '',
        },
        termsAndConditionsUrl: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        return {
            bonusSubtitle: computed(() => props.kind === BonusKind.Betler ? getBetlerBonusSummary(props.bonus.type, props.bonus.bonusAmount, props.bonus.rewardType, true) : undefined),
            promotionBonusName: props.kind === BonusKind.Betler ? props.bonus.name : props.bonusValue,
        };
    },
    components: {
        RulesAndRestrictionsSection,
        PromotionDetailsBonusSection,
    },
});
